webpackJsonp([102433428468292],{

/***/ 499:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Pandas are really sweet.</p>\n<p>Here's a video of a panda eating sweets.</p>\n<p><img src=\"/logo.png\" alt=\"logo\"></p>","frontmatter":{"title":"南京地震馆"}}},"pathContext":{"slug":"/solutions/南京地震馆/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---solutions-南京地震馆-9d966da1a639adfb5b61.js